var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{staticClass:"mt-12 no-print",attrs:{"color":"grey2","height":"60px"}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('b',{staticClass:"grey5--text",staticStyle:{"font-size":"13px"}},[_vm._v("\n      © "+_vm._s(new Date().getFullYear())+" Ambii, Inc\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }